import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';

@Injectable()
export class ExcelExportService {

	constructor() {
		// THIS IS INTENTIONAL
	}

	// FOR EXPORT CSV FILE.
	exportAsExcelFile = (json: any, excelFileName: string) => {

		const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json.sheet1);
		const worksheet2: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json.sheet2);

		const workbook: XLSX.WorkBook = { Sheets: { 'Sheet 1': worksheet, 'Sheet 2': worksheet2 }, SheetNames: ['Sheet 1', 'Sheet 2'] };
		XLSX.writeFile(workbook, `${excelFileName}.xlsx`);
	}
}